import Layout from '../components/Layout'

const Support = () => {
    return (
        <Layout>
            <h1>support</h1>
        </Layout>
    )
}

export default Support